import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://lhpjtppdlapbajcxzmhh.supabase.co";
const supabaseAnonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImxocGp0cHBkbGFwYmFqY3h6bWhoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzE5MzczNDEsImV4cCI6MjA4NzUxMzM0MX0.vBSKGcBVeLD4nojI0cvTt_oCDeLYuxb7vDcxomwCCyI";

// Note: if your Supabase table(s) have row-level security (RLS) enabled,
// the anon/public key used above must be granted appropriate permissions
// (e.g. an "INSERT" policy) for the client to write data. Otherwise,
// you'll see errors like "new row violates row-level security policy".
// Adjust policies in the dashboard under Table → Policies.
export const supabase = createClient(supabaseUrl, supabaseAnonKey);
